'use client';

import AkkaLink from '@commons/AkkaLink/AkkaLink';

export default function SiteHeaderLogo({ children, label = undefined }) {
  return (
    <AkkaLink className="SiteHeader__logo-link" href="/" aria-label={label}>
      {children}
    </AkkaLink>
  );
}
